import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, Plus, Search, X } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import { trackBeginListing } from "@/lib/analytics";

export default function Header() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const goNewListing = (source) => {
    trackBeginListing({ source });
    navigate("/novy-inzerat");
  };

  const navLinkClass = ({ isActive }) =>
    `stb-btn stb-btn-ghost text-xs ${isActive ? "text-[#FF6B00]" : ""}`;

  return (
    <header className="stb-header-bar" data-testid="site-header">
      <div className="stb-warning-strip" aria-hidden />
      <div className="stb-container flex items-center justify-between py-3">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <img src="/stavbos-logo-wide.png" alt="STAVBOŠ" className="h-9 md:h-10 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-2">
          <NavLink to="/" end className={navLinkClass} data-testid="nav-home">
            Inzeráty
          </NavLink>
          <NavLink to="/jak-to-funguje" className={navLinkClass} data-testid="nav-how">
            Jak to funguje
          </NavLink>
          <NavLink to="/moje-inzeraty-email" className={navLinkClass} data-testid="nav-lookup">
            <Search size={14} /> Moje inzeráty
          </NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <ThemeToggle />
          <button
            className="stb-btn stb-btn-primary"
            onClick={() => goNewListing("header")}
            data-testid="header-new-ad-btn"
          >
            <Plus size={16} /> Vložit inzerát zdarma
          </button>
        </div>

        <button
          className="md:hidden stb-btn stb-btn-ghost"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#262626] stb-mobile-menu" data-testid="mobile-menu">
          <div className="stb-container py-3 flex flex-col gap-2">
            <Link to="/" className="stb-btn stb-btn-ghost justify-start" onClick={() => setOpen(false)}>
              Inzeráty
            </Link>
            <Link to="/jak-to-funguje" className="stb-btn stb-btn-ghost justify-start" onClick={() => setOpen(false)}>
              Jak to funguje
            </Link>
            <Link to="/moje-inzeraty-email" className="stb-btn stb-btn-secondary justify-start" onClick={() => setOpen(false)}>
              <Search size={14} /> Moje inzeráty
            </Link>
            <div className="self-start"><ThemeToggle /></div>
            <Link
              to="/novy-inzerat"
              className="stb-btn stb-btn-primary justify-center"
              onClick={() => {
                trackBeginListing({ source: "header_mobile" });
                setOpen(false);
              }}
            >
              <Plus size={16} /> Vložit inzerát zdarma
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
